import { v1 } from 'uuid';
import React from 'react';
export const getImgUrl = (jpg: string) => require(`./images/${jpg}`);

export const getSvg = (jpg: string) => {
  return images[jpg];
  // return React.lazy(() => {
  //     return import(`./images/${jpg}`);
  // });
};

export type MockDataProductType = {
  id: string;
  img: string;
  title: string;
  type: string;
  description: JSX.Element;
  price: number;
  sale: boolean;
  category: CategoryType[];
};

export type CategoryType = {
  id: string;
  descr: string;
  count: number;
};

let mockDataProduct: MockDataProductType[] = [
  {
    id: v1(),
    img: 'towel/1.jpg',
    title: 'Полотенце махровое 100% хлопок',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/2.jpg',
    title: 'Полотенце махровое 100% хлопок',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/3.jpg',
    title: 'Полотенце махровое 100% хлопок',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/4.jpg',
    title: 'Полотенце махровое 100% хлопок',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/5.jpg',
    title: 'Полотенце махровое 100% хлопок',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/6.jpg',
    title: 'Полотенце махровое белое с рисунком',
    type: 'towel',
    category: [{ id: v1(), descr: '50x90(для рук)', count: 95 }],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/7.jpg',
    title: 'Полотенце махровое голубое с рисунком',
    type: 'towel',
    category: [{ id: v1(), descr: '50x90(для рук)', count: 95 }],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/8.jpg',
    title: 'Полотенце махровое кремовое с рисунком',
    type: 'towel',
    category: [{ id: v1(), descr: '50x90(для рук)', count: 95 }],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/9.jpg',
    title: 'ПОЛОТЕНЦЕ МАХРОВОЕ ЛЮРЕКС (100% Хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/10.jpg',
    title: 'Полотенце махровое люрекс (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/11.jpg',
    title: 'Полотенце махровое люрекс (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/12.jpg',
    title: 'Полотенце махровое люрекс (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/13.jpg',
    title: 'Полотенце махровое люрекс (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/14.jpg',
    title: 'Полотенце махровое люрекс (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/15.jpg',
    title: 'Полотенце махровое люрекс (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/16.jpg',
    title: 'ПОЛОТЕНЦЕ МАХРОВОЕ РОЗОВОЕ С РИСУНКОМ, 50Х90 СМ',
    type: 'towel',
    category: [{ id: v1(), descr: '50x90(для рук)', count: 95 }],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/17.jpg',
    title: 'Полотенце махровое, белое 50х90 см',
    type: 'towel',
    category: [{ id: v1(), descr: '50x90(для рук)', count: 95 }],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/18.jpg',
    title: 'Полотенце махровое, зеленое 50х90 см',
    type: 'towel',
    category: [{ id: v1(), descr: '50x90(для рук)', count: 95 }],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/19.jpg',
    title: 'Полотенце махровое, синее 50х90 см',
    type: 'towel',
    category: [{ id: v1(), descr: '50x90(для рук)', count: 95 }],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/20.jpg',
    title: 'ПОЛОТЕНЦЕ МАХРОВОЕ С УЗОРОМ (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/21.jpg',
    title: 'ПОЛОТЕНЦЕ МАХРОВОЕ С УЗОРОМ (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 102 },
      { id: v1(), descr: '70x140(для тела)', count: 195 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 136,
    sale: true,
  },
  {
    id: v1(),
    img: 'towel/22.jpg',
    title: 'ПОЛОТЕНЦЕ МАХРОВОЕ С УЗОРОМ (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/23.jpg',
    title: 'ПОЛОТЕНЦЕ МАХРОВОЕ С УЗОРОМ (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/24.jpg',
    title: 'ПОЛОТЕНЦЕ МАХРОВОЕ С УЗОРОМ (100% хлопок)',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x90(для рук)', count: 95 },
      { id: v1(), descr: '70x140(для тела)', count: 190 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 400 г/м2), махровое</p>,
    price: 95,
    sale: false,
  },
  {
    id: v1(),
    img: 'towel/25.jpg',
    title: 'Полотенце белое 1',
    type: 'towel',
    category: [
      { id: v1(), descr: '50x70(для рук)', count: 165 },
      { id: v1(), descr: '50x90(для тела)', count: 180 },
      { id: v1(), descr: '70x140(для тела)', count: 330 },
    ],
    description: <p>полотенце из 100% хлопка (махра, плотность: 450 г/м2), махровое</p>,
    price: 220,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/55.jpg',
    title: 'Комплект постельного белья Мальва',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/1.jpg',
    title: 'Комплект постельного белья (2020 - 3)',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/38.jpg',
    title: 'Комплект постельного белья Голд Элис',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/39.jpg',
    title: 'Комплект постельного белья Динозавр',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/2.jpg',
    title: 'КОМПЛЕКТ ПОСТЕЛЬНОГО БЕЛЬЯ PINK DREAMS',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/64.jpg',
    title: 'Комплект постельного белья Фиона',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/65.jpg',
    title: 'Комплект постельного белья Радость',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/3.jpg',
    title: 'Комплект постельного белья Айгуль',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/44.jpg',
    title: 'Комплект постельного белья Зара',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/45.jpg',
    title: 'Комплект постельного белья Кактус',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/46.jpg',
    title: 'Комплект постельного белья Камелия',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/4.jpg',
    title: 'Комплект постельного белья Амина',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/48.jpg',
    title: 'Комплект постельного белья Корнелия',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/49.jpg',
    title: 'Комплект постельного белья Лейла',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/5.jpg',
    title: 'Комплект постельного белья Афродита',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/6.jpg',
    title: 'Комплект постельного белья Белла',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/54.jpg',
    title: 'Комплект постельного белья Мадагаскар',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/56.jpg',
    title: 'Комплект постельного белья Маргарита',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/57.jpg',
    title: 'tКомплект постельного белья Милена',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/7.jpg',
    title: 'Комплект постельного белья Малва',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/59.jpg',
    title: 'Комплект постельного белья Богаство',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/60.jpg',
    title: 'Комплект постельного белья Оливия',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/8.jpg',
    title: 'Комплект постельного белья Виолетта',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/9.jpg',
    title: 'Комплект постельного белья Динара',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/63.jpg',
    title: 'Комплект постельного белья Синара',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/66.jpg',
    title: 'Комплект постельного белья Мексика',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/67.jpg',
    title: 'Постельное белье бязь голд Ола',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/10.jpg',
    title: 'Комплект постельного белья Земфира',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/69.jpg',
    title: 'Постельное белье бязь голд Лирика',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/70.jpg',
    title: 'Постельное белье бязь голд Серое',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/11.jpg',
    title: 'Комплект постельного белья Клариса',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/75.jpg',
    title: 'Белое - СТРАЙП- САТИН БЕЖЕВЫЙ',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 1200 },
      { id: v1(), descr: 'Двуспальный ', count: 1500 },
      { id: v1(), descr: 'Евро', count: 1550 },
      { id: v1(), descr: 'Семейный ', count: 1900 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 1200,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/12.jpg',
    title: 'Комплект постельного белья Луиза',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/76.jpg',
    title: 'Черное - СТРАЙП- САТИН СЕРЫЙ',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 1200 },
      { id: v1(), descr: 'Двуспальный ', count: 1500 },
      { id: v1(), descr: 'Евро', count: 1550 },
      { id: v1(), descr: 'Семейный ', count: 1900 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 1200,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/13.jpg',
    title: 'Комплект постельного белья Рая',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/14.jpg',
    title: 'Комплект постельного белья Хамели',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },

  {
    id: v1(),
    img: 'linens/68.jpg',
    title: 'Постельное белье бязь голд Афина',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/71.jpg',
    title: 'Комплект постельного белья Софа',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/72.jpg',
    title: 'Комплект постельного белья Иринс',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/15.jpg',
    title: 'Комплект постельного белья Элеонора',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/62.jpg',
    title: 'Комплект постельного белья с Валентина',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/73.jpg',
    title: 'Комплект постельного белья 2021-12',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/16.jpg',
    title: 'Комплект постельного белья (2020 - 6)',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/17.jpg',
    title: 'Комплект постельного белья 2020 - 2',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/18.jpg',
    title: 'Комплект постельного белья 2020 - 1',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/52.jpg',
    title: 'Комплект постельного белья Лили',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/53.jpg',
    title: 'Комплект постельного белья Лимбо',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/58.jpg',
    title: 'Комплект постельного белья Миранда',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/61.jpg',
    title: 'Комплект постельного белья Пайпер',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/74.jpg',
    title: 'Комплект постельного белья (2020-5)',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/19.jpg',
    title: 'Комплект постельного белья Tropic',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/20.jpg',
    title: 'Комплект постельного белья Авроро',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/21.jpg',
    title: 'Комплект постельного белья Айза',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/22.jpg',
    title: 'Комплект постельного белья Алекса',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/43.jpg',
    title: 'Комплект постельного белья Жасмин',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/47.jpg',
    title: 'Комплект постельного белья Кейли',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/50.jpg',
    title: 'Комплект постельного белья Очарование',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/23.jpg',
    title: 'Комплект постельного белья Александра',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/24.jpg',
    title: 'Комплект постельного белья Алисса',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/25.jpg',
    title: 'Комплект постельного белья Аманда',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/26.jpg',
    title: 'Комплект постельного белья Асена',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/27.jpg',
    title: 'Комплект постельного белья Белинда',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/41.jpg',
    title: 'Комплект постельного белья Елизавета',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/42.jpg',
    title: 'Комплект постельного белья Жаклин',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },

  {
    id: v1(),
    img: 'linens/51.jpg',
    title: 'Комплект постельного белья Катерина',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
  {
    id: v1(),
    img: 'linens/28.jpg',
    title: 'Комплект постельного белья бязь голд',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/29.jpg',
    title: 'КОМПЛЕКТ ПОСТЕЛЬНОГО БЕЛЬЯ БЯЗЬ ГОЛД LEAF',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/30.jpg',
    title: 'КОМПЛЕКТ ПОСТЕЛЬНОГО БЕЛЬЯ БЯЗЬ ГОЛД КЛАРА',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/31.jpg',
    title: 'КОМПЛЕКТ ПОСТЕЛЬНОГО БЕЛЬЯ БЯЗЬ ГОЛД РОУЗИ',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/32.jpg',
    title: 'Комплект постельного белья бязь голд премиум',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/33.jpg',
    title: 'Комплект постельного белья в клетку',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/34.jpg',
    title: 'Комплект постельного белья Валерия',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/35.jpg',
    title: 'Комплект постельного белья Веста',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/36.jpg',
    title: 'Комплект постельного белья Виктория',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },
  {
    id: v1(),
    img: 'linens/37.jpg',
    title: 'Комплект постельного белья Виталина',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 450 },
      { id: v1(), descr: 'Двуспальный ', count: 550 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 450,
    sale: false,
  },

  {
    id: v1(),
    img: 'linens/40.jpg',
    title: 'Комплект постельного белья Виктория',
    type: 'linens',
    category: [
      { id: v1(), descr: 'Полуторный', count: 465 },
      { id: v1(), descr: 'Двуспальный ', count: 570 },
      { id: v1(), descr: 'Евро', count: 600 },
      { id: v1(), descr: 'Семейный ', count: 700 },
    ],
    description: <p>Хлопок, полиэстер</p>,
    price: 620,
    sale: true,
  },
];

type ImagesType = {
  [key: string]: string;
};

export const images: ImagesType = {};

mockDataProduct.forEach((p) => {
  const img = require(`./images/${p.img}`);
  images[p.id] = img.default;
});

export default mockDataProduct;
